import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import List from './List'
import Table from './Table'
import { observer } from 'mobx-react'
import store from './store'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id }
    } = this.props

    store.id = id
  }

  componentDidMount() {
    store.getDetail()
  }

  render() {
    let title = [
      <a href="#/localMerchant/settlementManage">结算管理</a>,
      <a href="#/localMerchant/settlementManage/history">账单列表</a>,
      '流水详情'
    ]
    return (
      <HeaderView title="流水详情" header={title}>
        <List />
        <Table />
      </HeaderView>
    )
  }
}
